import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import Grid from '@material-ui/core/Grid';
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import classnames from 'classnames';
import MultiUtilityChart from "../../../../../../../components/reusable/Recharts/MultiUtilityChart";
import {Distributions} from "../../../../../../../components/reusable/AttributeDistributions";


class CountWithBar extends React.Component {

    render() {
        const { classes, value, label, percent, barType = undefined } = this.props;
        return (
            <Grid container>
                <Grid item xs={3}>
                    <Paper elevation={0} className={classes.paper}>
                        <Typography variant="subheading">{label}</Typography>
                        <Typography variant="body2">{value}</Typography>
                    </Paper>
                </Grid>
                <Grid item xs>
                    <LinearProgress
                        classes={{
                            root: classes.progress,
                            bar: classes[barType]
                        }}
                        variant="determinate" value={percent}
                    />
                </Grid>
            </Grid>
        );
    }
}

const COLORS = ["#8650A7", "#009999", "#00CC00"];

const BAR_TYPES = {
    barDefault: 'barDefault',
    barReached: 'barReached',
    barConverted: 'barConverted'
};

const { barDefault, barReached, barConverted } = BAR_TYPES;

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    paper:{
        textAlign: 'center',
        padding: theme.spacing.unit * 2,
        margin: `${theme.spacing.unit}px 0`
    },
    progress: {
        height: theme.spacing.unit,
        marginTop: theme.spacing.unit * 6
    },
    [barDefault]: {
        background: COLORS[0]
    },
    [barReached]: {
        background: COLORS[1],
    },
    [barConverted]: {
        background: COLORS[2],
    }
});

const mockSeries = [
    { date: '2018-12-20', targeted: 1234, reached: 800, converted: 120 },
    { date: '2018-12-21', targeted: 1434, reached: 1000, converted: 280 },
    { date: '2018-12-22', targeted: 1334, reached: 900, converted: 220 },
];

const mockDistribution = {"age":{"mainData":[{"key":"18","value":1007,"fill":"#4caf50"},{"key":"20","value":593,"fill":"#ffa726"},{"key":"19","value":581,"fill":"#9c27b0"},{"key":"22","value":461,"fill":"#f57f17"},{"key":"21","value":453,"fill":"#2196f3"},{"key":"23","value":447,"fill":"#009688"},{"key":"17","value":389,"fill":"#f44336"},{"key":"24","value":363,"fill":"#ffc107"},{"key":"25","value":339,"fill":"#795548"},{"key":"others","value":4232,"fill":"#9e9e9e"}],"remainData":[{"key":"16","value":299},{"key":"26","value":294},{"key":"28","value":266},{"key":"27","value":263},{"key":"15","value":211},{"key":"29","value":203},{"key":"30","value":177},{"key":"14","value":175},{"key":"31","value":167},{"key":"33","value":146},{"key":"34","value":131},{"key":"32","value":127},{"key":"38","value":121},{"key":"35","value":107},{"key":"13","value":104},{"key":"37","value":95},{"key":"36","value":90},{"key":"39","value":84},{"key":"40","value":75},{"key":"12","value":72},{"key":"44","value":70},{"key":"41","value":65},{"key":"42","value":65},{"key":"43","value":62},{"key":"45","value":53},{"key":"48","value":53},{"key":"47","value":52},{"key":"11","value":51},{"key":"46","value":40},{"key":"51","value":34},{"key":"49","value":32},{"key":"50","value":32},{"key":"10","value":30},{"key":"53","value":30},{"key":"54","value":28},{"key":"9","value":28},{"key":"52","value":27},{"key":"58","value":23},{"key":"7","value":22},{"key":"0","value":21},{"key":"8","value":21},{"key":"55","value":19},{"key":"57","value":19},{"key":"56","value":16},{"key":"60","value":14},{"key":"6","value":13},{"key":"61","value":12},{"key":"5","value":11},{"key":"59","value":11},{"key":"67","value":11},{"key":"64","value":10},{"key":"4","value":7},{"key":"63","value":6},{"key":"62","value":5},{"key":"65","value":5},{"key":"66","value":4},{"key":"69","value":4},{"key":"70","value":4},{"key":"3","value":3},{"key":"68","value":2},{"key":"72","value":2},{"key":"83","value":2},{"key":"1","value":1},{"key":"118","value":1},{"key":"71","value":1},{"key":"73","value":1},{"key":"75","value":1},{"key":"80","value":1},{"key":"apx_uninstall","value":0}]},"tradition":{"mainData":[{"key":"Hindustani","value":5605,"fill":"#4caf50"},{"key":"Western","value":2225,"fill":"#ffa726"},{"key":"Bollywood","value":1272,"fill":"#9c27b0"},{"key":"Carnatic","value":948,"fill":"#f57f17"},{"key":"apx_uninstall","value":0,"fill":"#2196f3"}],"remainData":[]},"fb_timezone":{"mainData":[{"key":"5.5","value":361,"fill":"#4caf50"},{"key":"2","value":38,"fill":"#ffa726"},{"key":"-5","value":36,"fill":"#9c27b0"},{"key":"-4","value":25,"fill":"#f57f17"},{"key":"1","value":21,"fill":"#2196f3"},{"key":"3","value":21,"fill":"#009688"},{"key":"-7","value":16,"fill":"#f44336"},{"key":"5","value":15,"fill":"#ffc107"},{"key":"8","value":14,"fill":"#795548"},{"key":"others","value":78,"fill":"#9e9e9e"}],"remainData":[{"key":"0","value":11},{"key":"-3","value":10},{"key":"-8","value":9},{"key":"7","value":8},{"key":"6","value":7},{"key":"4","value":6},{"key":"5.75","value":6},{"key":"11","value":5},{"key":"-6","value":3},{"key":"10","value":3},{"key":"6.5","value":2},{"key":"9","value":2},{"key":"-3.75","value":1},{"key":"-5.25","value":1},{"key":"-9","value":1},{"key":"12","value":1},{"key":"4.25","value":1},{"key":"4.5","value":1},{"key":"apx_uninstall","value":0}]}};

class ResultsWrapper extends React.Component {

    render() {
        const { classes } = this.props;
        return (
            <Fragment>
                <CountWithBar
                    {...this.props}
                    label="Targeted"
                    value={123456}
                    percent={100}
                    barType={barDefault}
                />
                <CountWithBar
                    {...this.props}
                    label="Reached"
                    value={83443}
                    percent={76}
                    barType={barReached}
                />
                <CountWithBar
                    {...this.props}
                    label="Converted"
                    value={10346}
                    percent={10}
                    barType={barConverted}
                />
                <MultiUtilityChart
                    colors={COLORS}
                    data={mockSeries}
                    dataKey="date"
                    areaDataKeys={["targeted", "reached", "converted"]}
                    withHeader
                    title="Trend"
                    withoutAggregations
                />
                <Distributions
                    {...this.props}
                    data={mockDistribution}
                    notSelectable
                />
            </Fragment>
        );
    }
}

ResultsWrapper.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ResultsWrapper);